module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "single"
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("账户信息")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(0), _vm._v(" "), (!_vm.role.isCashier) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "info_wrapper"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v("登录账号")]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.shop.mobile))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v("店铺名称")]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.shop.shopname))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v("地址")]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.shop.address))])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v("手机号")]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.shop.telephone || '无'))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v("持卡人")]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.shop.bankuser))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v("银行账户")]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.shop.bankaccount) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v("银行名称")]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.shop.bankname))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-btn-group__wrapper"
  }, [_c('a', {
    attrs: {
      "href": _vm.downHref,
      "download": ""
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "panel-btn__download panel-btn__download_record",
    on: {
      "click": function($event) {
        return _vm.changePass(_vm.shop.mobile)
      }
    }
  }, [_vm._v("修改密码")])])])]) : _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "info_wrapper"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v("账户状态")]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.opinfo.status ? '启用账户' : '禁用账户'))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.opinfo.opname))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v("电话")]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.opinfo.mobile))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v("门店")]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.shop.shopname))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v("主账号")]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.shop.mobile))])]), _vm._v(" "), _c('div', {
    staticClass: "info next-bottom"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v("收银员编号")]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.opinfo.opuid))])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "info next-bottom"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v("退款权限")]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.opinfo.refund ? '有权限' : '无权限'))])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "panel-btn-group__wrapper"
  }, [_c('a', {
    attrs: {
      "href": _vm.downHref,
      "download": ""
    }
  }, [_vm._m(4)])])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改密码",
      "visible": _vm.showChangePass,
      "custom-class": "mydialog",
      "top": "20%",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showChangePass = $event
      },
      "close": _vm.handleClose
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.formrules,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "登录账号"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.userName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "输入新密码",
      "prop": "pass"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "password",
      "placeholder": "请输入新密码"
    },
    model: {
      value: (_vm.form.pass),
      callback: function($$v) {
        _vm.$set(_vm.form, "pass", $$v)
      },
      expression: "form.pass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认新密码",
      "prop": "repass"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "password",
      "placeholder": "请输入确认新密码"
    },
    model: {
      value: (_vm.form.repass),
      callback: function($$v) {
        _vm.$set(_vm.form, "repass", $$v)
      },
      expression: "form.repass"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "cancel",
    on: {
      "click": function($event) {
        _vm.showChangePass = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('div', {
    staticClass: "submit",
    on: {
      "click": _vm.submit
    }
  }, [(_vm.iconShow) ? _c('span', {
    staticClass: "el-icon-loading"
  }) : _c('span', [_vm._v("确定")])])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-header panel-header__fix"
  }, [_c('div', {
    staticClass: "panel-select-group panel-select-group__justify"
  }, [_c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v("基本信息")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-btn__download panel-btn__download_detail"
  }, [_c('i', {
    staticClass: "icon-download"
  }), _vm._v(" "), _c('span', [_vm._v("下载店铺收款码")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }), _vm._v(" "), _c('div', {
    staticClass: "gray-explain"
  }, [_vm._v("* 收银员登陆方式为主账号+收银员编号+收银员密码")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }), _vm._v(" "), _c('div', {
    staticClass: "gray-explain"
  }, [_vm._v("* 目前收银员仅支持查看活动信息，不支持对红包、集点、储值活动、特卖、店铺公告、会员特权的增删改")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-header-btn panel-header-btn__fill"
  }, [_c('i', {
    staticClass: "icon-download"
  }), _vm._v(" "), _c('span', [_vm._v("下载收款二维码")])])
}]}


//////////////////
// WEBPACK FOOTER
// /home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin/~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-114ca716"}!/home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin/~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/singlemanage/singlemanage.vue
// module id = 810
// module chunks = 0